import AnalyseDataTrainTabs from "./AnalyseDataTrainTabs";

export default AnalyseDataTrainTabs;